import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SuReceiptService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/su-receipts', params);
    }

    show(suReceiptId: number): Observable<any> {
        return super.get(`/su-receipts/${suReceiptId}`);
    }

    labelLines(suReceiptId: number): Observable<any> {
        return super.get(`/su-receipts/${suReceiptId}/label-lines`);
    }

    previewLabelLines(body: any): Observable<any> {
        return super.post('/su-receipts/label-lines', body);
    }

    indexLines(params: any): Observable<any> {
        return super.get('/su-receipt-lines', params);
    }

    edit(suReceiptId: number) {
        return super.get(`/su-receipts/${suReceiptId}/edit`);
    }

    update(suReceiptId: number, body: any) {
        return super.put(`/su-receipts/${suReceiptId}`, body);
    }

    destroy(suReceiptId: number): Observable<any> {
        return super.delete(`/su-receipts/${suReceiptId}`);
    }

    close(suReceiptId: number): Observable<any> {
        return super.post(`/su-receipts/${suReceiptId}/close`, {});
    }

    send(body: any): Observable<any> {
        return super.post('/su-receipts/send', body);
    }

    fromLines(body: any): Observable<any> {
        return super.post('/su-receipts/from-lines', body);
    }

    storeWithOrder(body: any): Observable<any> {
        return super.post('/su-receipts/store-with-order', body);
    }

    confirm(suReceiptId: number, body: any = {}): Observable<any> {
        return super.post(`/su-receipts/${suReceiptId}/confirm`, body);
    }
}
